// extracted by mini-css-extract-plugin
export default {"button":"kR5PdglGjIodfN2hXvRN","primary":"WNj8UottyUwV4h76Q7TA","secondary":"D4cWgD7E5Oc0Mtq2P7Q8"};